export default {
  fields: {
    action_status_id: "Etat de l'action",
    action_plan_status: "Etat du plan d'actions",
  },
  filters: {
    closingDateTitle: 'Date de clôture',
    closingDateLabel: 'A partir du',
    title: 'Reporting PEM',
    entity: 'Entité',
    persons_in_charge: 'Personnes en charge',
  },
  graphTitles: {
    actionPlanReporting: "Plans d'actions",
    actionPriorityReporting: 'Actions - Priorité',
    actionTypeReporting: 'Actions - Type',
    deadlineReporting: "Actions - Échéances par type de plan d'action",
    actionGainReporting: 'Actions - Gains %',
  },
  icon: 'mdi-chart-bar',
  name: 'Tableau de bord reporting',
  subtitles: {
    actions: `Plans d'actions / Actions`,
    noData: 'Pas de données avec les filtres sélectionnés.',
  },
};
